<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="promotion">
        <p>
          <span class="promotion__back">
            <routerLink to="/promotion">Promotion</routerLink>
          </span> >
          <span class="promotion__current">New promotion</span>
        </p>
        <div class="promotion__header">
          <div class="promotion__header--text">Add New Promotion</div>
          <div class="promotion__header--edit"></div>
        </div>

        <div class="promotion__body">
          <div>
            <div class="data-fetch-error" v-show="dataFetchError">
              <p>This page did not load successfully. Please refesh.</p>
            </div>
          </div>

          <div class="promotion__body--content">
            <div class="promotion__body--conten-img">
              <div>
                <img src="./../../../assets/images/promotion.svg" alt />
              </div>
              <p>Add New Promotion</p>
            </div>

            <div class="promotion__body--content-loader" v-if="pageload">
              <div>
                <PageLoader />
              </div>
            </div>

            <div class="promotion__body--content-form" v-if="!pageload">
              <div>
                <div class="promotion__body--content-form-name">Promotion For:</div>
                <div class="promotion__body--content-form-input">
                  <select v-model.trim="newPromotion.employee_id" @change="getPresentDesignation">
                    <option
                      :value="employee.id"
                      v-for="(employee, index) in employees"
                      :key="index"
                    >{{employee.user.firstname}} {{employee.user.lastname}}</option>
                  </select>
                </div>
              </div>
              <div>
                <div class="promotion__body--content-form-name">Current Position:</div>
                <div class="promotion__body--content-form-input">
                  <input type="text" v-model.trim="presentDesignation.name" />
                </div>
              </div>
              <div>
                <div class="promotion__body--content-form-name">Promotion To:</div>
                <div class="promotion__body--content-form-input">
                  <select v-model.trim="newPromotion.new_designation_id">
                    <option
                      :value="designation.id"
                      v-for="(designation, index) in designations"
                      :key="index"
                    >{{designation.name}}</option>
                  </select>
                </div>
              </div>
      

              <div>
                <div class="error">
                  <p v-if="dataSaveError">{{dataSaveError}}</p>
                  <div v-if="serverErrors">
                    <p v-for="(value, name, index) in serverErrors" :key="index">{{value[0]}}</p>
                  </div>
                </div>
              </div>

              <div>
                <div
                  class="promotion__body--content-btn"
                  @click.prevent="promoteEmployee()"
                  v-if="!loading"
                >Save & Submit</div>
                <div class="promotion__body--content-btn" v-else>
                  <WhiteLoader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

export default {
  name: "AddPromotion",

  components: {
    Header,
    Sidebar,
    WhiteLoader,
    PageLoader
  },

  data() {
    return {
      item: "promotion",
      hr: "hr",
      employees: [],
      designations: [],

      presentDesignation: {},

      newPromotion: {
        level_id: "",
        employee_id: null,
        new_designation_id: "",
        present_designation_id: ""
      },

      loading: false,
      pageload: true,

      serverErrors: null,
      dataFetchError: false,
      dataSaveError: " "
    };
  },

  created() {
    this.getDesignations();
    this.getEmployees();
  },

  methods: {
    getDesignations() {
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then(resp => {
          this.designations = resp.data.data;
        })
        .catch(err => {
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    getEmployees() {
      this.$http
        .get(types.GET_EMPLOYEES_API)
        .then(resp => {
          this.employees = resp.data.data.data;
          this.pageload = false;
        })
        .catch(err => {
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    getPresentDesignation() {
      this.employees.forEach(employee => {
        if (employee.id === this.newPromotion.employee_id) {
          if (employee.designations) {
            this.presentDesignation.name = employee.designations.name;
          } else {
            this.presentDesignation.name = "";
          }
        }
      });
    },

    promoteEmployee() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (!this.newPromotion.employee_id) {
        this.dataSaveError = "All the input fields are required";
        return;
      }

      this.newPromotion.present_designation_id =
        this.presentDesignation.id || "null";

      const data = {};

      Object.keys(this.newPromotion).forEach(val => {
        if (val !== "employee_id") {
          data[val] = String(this.newPromotion[val]);
        } else {
          data[val] = this.newPromotion[val];
        }
      });

      this.loading = true;

      this.$http
        .post(types.PROMOTION_API, data)
        .then(() => {
          this.loading = false;
          this.$router.push("/promotion");
        })
        .catch(err => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    margin-top: 7rem;
    width: 15%;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;
    height: 100vh;

    @media (max-width: 768px) {
      margin-top: 4rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.promotion {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .data-fetch-error {
    margin-top: 10px;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
    p {
      margin-bottom: 0;
      padding-top: 20px;
      text-align: left;
    }
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
  }

  .error > p {
    margin: 0;
  }

  > p {
    font-size: 0.938rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .promotion__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .promotion__current {
      color: #707070;
    }
  }

  .promotion__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    > .promotion__header--text {
      width: 500px;
      font-size: 2.083rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .promotion__header--edit {
      width: 150px;
      font-size: 1.25rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: 0.72px;
      text-align: left;
      color: #5099de;
      text-align: right;
      cursor: pointer;
    }
  }

  > .promotion__body {
    border-top: 1px solid #caced5;
    padding: 0 30px 0 5px;

    > .promotion__body--content {
      margin-top: 50px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding: 50px;

      > .promotion__body--conten-img {
        margin-bottom: 50px;
        > div {
          width: 5.729vw;
          margin: auto;
        }

        > p {
          font-size: 1.458rem;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-top: 30px;
        }
      }

      > .promotion__body--content-loader {
        > div {
          width: 55px;
          margin: 0 auto;
        }
      }

      > .promotion__body--content-form {
        > div {
          max-width: 500px;
          margin: 0 auto 50px auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          align-content: center;

          > .promotion__body--content-form-name {
            width: 200px;
          }

          > .promotion__body--content-form-input {
            height: 40px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            overflow: hidden;

            > input {
              height: 40px;
              border: solid 1px #caced5;
              background-color: #ffffff;
              outline: 0;
              border: 0;
              padding: 0 5px;
              font-size: 0.938rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }

            > select {
              height: 40px;
              border: solid 1px #caced5;
              background-color: #ffffff;
              outline: 0;
              border: 0;
              padding: 0 5px;
              font-size: 0.938rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }
          }

          > .promotion__body--content-btn {
            width: 9.063rem;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 0.938rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
